import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./pages/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NoPage from "./pages/NoPage";

import FloatingInstagramBar from "./components/FloatingInstagram";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>

      {/* Barra inferior */}
      <FloatingInstagramBar
        label="Visita nuestro Instagram"
        bottom={0}
        height={56}
        rounded={0}
        showLabelOnMobile
        zIndex={2000}
      />
    </BrowserRouter>
  );
};

export default App;
